'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ISOBitMapPackager2 = require('./ISOBitMapPackager');

var _ISOBitMapPackager3 = _interopRequireDefault(_ISOBitMapPackager2);

var _ISOComponent = require('../ISOComponent');

var _ISOComponent2 = _interopRequireDefault(_ISOComponent);

var _ISOUtil = require('../ISOUtil');

var _ISOUtil2 = _interopRequireDefault(_ISOUtil);

var _BitSet = require('jsdk/util/BitSet');

var _BitSet2 = _interopRequireDefault(_BitSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Bruno bruno.camargos@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2016/01/15
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var IFA_BITMAP = function (_ISOBitMapPackager) {
    _inherits(IFA_BITMAP, _ISOBitMapPackager);

    function IFA_BITMAP(len, description) {
        _classCallCheck(this, IFA_BITMAP);

        return _possibleConstructorReturn(this, (IFA_BITMAP.__proto__ || Object.getPrototypeOf(IFA_BITMAP)).call(this, len, description));
    }

    _createClass(IFA_BITMAP, [{
        key: 'pack',
        value: function pack(field) {
            var b = field.getValue();
            var len = this.getLength() >= 8 ? b.length() + 62 >> 6 << 3 : this.getLength();

            return _ISOUtil2.default.str2bytes(_ISOUtil2.default.hexString(_ISOUtil2.default.bitSet2byte(b, len)));
        }
    }, {
        key: 'getMaxPackedLength',
        value: function getMaxPackedLength() {
            return this.getLength() >> 2;
        }
    }, {
        key: 'unpack',
        value: function unpack(field, msg, offset) {
            var len = void 0,
                bmap = _ISOUtil2.default.hex2BitSet(msg, offset, this.getLength() << 3);
            field.setValue(bmap);

            len = bmap.get(1) ? 128 : 64;
            if (this.getLength() > 16 && bmap.get(65)) {
                len = 192;
                bmap.clear(65);
            }

            return Math.min(this.getLength() << 1, len >> 2);
        }
    }]);

    return IFA_BITMAP;
}(_ISOBitMapPackager3.default);

exports.default = IFA_BITMAP;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/packer/IFA_BITMAP.js
// module id = 70
// module chunks = 0